import { fromJS } from 'immutable';
import { DISCARD_FROM_PLAY, END_DISCARD_FROM_PLAY, END_LOOK, LOOK } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  /** Computer Search or Pokédex: the picks from the deck are on their way to the server. */
  looking: false,
  /** Clefairy Doll is on its way to the discard pile. */
  discarding: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case LOOK:
      return state.set('looking', true);

    case END_LOOK:
      return state.set('looking', false);

    case DISCARD_FROM_PLAY:
      return state.set('discarding', true);

    case END_DISCARD_FROM_PLAY:
      return state.set('discarding', false);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
